import type { ReactNode } from "react";

/** The points of a starburst in a 100 by 100 box. */
const POINTS = Array.from({ length: 24 }, (_, i) => {
  const r = i % 2 ? 36 : 48;
  const a = (Math.PI * 2 * i) / 24 - Math.PI / 2;
  return `${(50 + r * Math.cos(a)).toFixed(1)},${(50 + r * Math.sin(a)).toFixed(1)}`;
}).join(" ");

/** A starburst sticker with a word or a number on it: a win. */
export function Burst({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span className={"burst" + (className ? ` ${className}` : "")}>
      <svg viewBox="0 0 100 100" aria-hidden="true">
        <polygon points={POINTS} />
      </svg>
      <strong>{children}</strong>
    </span>
  );
}
